import React from 'react'

import { Span } from 'components'
import { COLORS } from 'utils'

import { TitleContainer, Content, Container } from './CardChart.styles'

interface ICardChart {
  titleCard: string
  margin?: string
  headerFontSize?: string
  type?: 'normal' | 'danger' | 'success'
}
const CardChart: React.FC<ICardChart> = ({
  children,
  titleCard,
  margin,
  headerFontSize,
  type
}) => {
  const getColorTitle = () => {
    switch (type) {
      case 'normal':
        return COLORS.blueFonts
      case 'danger':
        return COLORS.white
      case 'success':
        return COLORS.white
      default:
        return COLORS.blueFonts
    }
  }

  return (
    <Container margin={margin}>
      <TitleContainer type={type}>
        <Span
          text={titleCard}
          fontSize={headerFontSize || '23px'}
          color={getColorTitle()}
          fontWeight="700"
        />
      </TitleContainer>
      <Content>{children}</Content>
    </Container>
  )
}

export default CardChart
